const InstructionsBadge = ({ instructionsRead, onClick, alwaysVisible = false, style = {} }) => {
  // Если не alwaysVisible и инструкция прочитана - не показываем
  if (!alwaysVisible && instructionsRead) {
    return null;
  }

  const className = alwaysVisible
    ? `instructions-badge instructions-badge--always-visible ${
        !instructionsRead ? 'instructions-badge--unread' : ''
      }`
    : `instructions-badge ${!instructionsRead ? 'instructions-badge--unread' : ''}`;

  const title = instructionsRead
    ? 'Переглянути інструкцію'
    : 'Нова інструкція! Натисніть для перегляду';

  return (
    <div
      className={className}
      onClick={onClick}
      title={title}
      style={{ cursor: 'pointer', ...style }}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginRight: '8px' }}
      >
        <path
          d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
          fill="currentColor"
        />
      </svg>
      <span className="instructions-badge__text">Інструкція</span>
      {!instructionsRead && <span className="instructions-badge__dot"></span>}
    </div>
  );
};

export default InstructionsBadge;
